module.exports = require("@mui/icons-material/BugReport");